import { BaseAction } from './BaseAction';
import Locale from '../../utils/Locale';

export class ShareRemoved extends BaseAction {
    public static getTitle:Function = () => Locale.gettext('Share Removed');
    public static getDescription:Function = () => Locale.gettext('A user removed their shared access');
    
}